import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getCounties } from "../../slices/codeBookSlice";

export const useGetCounties = () => {
  const counties = useSelector((state: RootState) => state.codeBook.counties);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCounties());
  }, [dispatch]);

  return counties;
};
